import React from "react";
import { useAuth } from "../../contexts/authContext/index.jsx";
import { useNavigate, Link } from 'react-router'

import { app } from '../../firebase/firebase.js';
import { getPremiumStatus } from "../stripe/subscriptionStatus.ts";
import { useEffect, useState } from "react";
import { auth } from "../../firebase/firebase.js";
import { setIsAdmin } from "../../firebase/telemetry";
import { logError } from "../../firebase/errorReporting";

export const AdminGaurd = ({ component: C }) => {
  const { userLoggedIn } = useAuth();

  const navigate = useNavigate()
  const [page, setPage] = useState(<div className="page-layout"></div>);

  useEffect(() => {
    // Hitting /admin directly before auth resolves leaves currentUser null, and
    // the unguarded property access threw a TypeError that nothing caught.
    if (!auth.currentUser) return;

    auth.currentUser.getIdTokenResult()
    .then((idTokenResult) => {
      const isAdmin = !!idTokenResult.claims.admin;
      setIsAdmin(isAdmin);
      if (isAdmin) {
        // Show admin UI.
        setPage(<C />);
      } else {
        // Show regular user UI.
        navigate('/')
      }
    })
    .catch(err => {
      logError(err, { component: 'AdminGaurd' });
      navigate('/')
    })
  }, [app, auth.currentUser?.uid]);
  return (
    <>
      {page}
    </>
  )
};